<template>
  <div>
    <transition name="partialloader">
      <div v-if="!isPagesLoaded" class="pageloader partial">
        <span class="loading-text">{{loadingText}}</span>
      </div>
    </transition>
    <section v-if="isPagesLoaded" class="detail-about">

      <header class="page-header">
        <h2 class="title basic"><span class="icon-conic"></span>{{context.title}}</h2>
      </header>

      <div class="container">
        <div class="card has-detail">
          <div class="card-content">

            <div class="content">
              <stream-field
                :items="context.body"
              ></stream-field>
            </div>

            <div class="utilities">
              <div class="utility-item">
                <ul class="sns">
                  <li class="item-sns"><a><span class="icon-twitter"></span></a></li>
                  <li class="item-sns"><a><span class="icon-facebook"></span></a></li>
                  <li class="item-sns"><a><span class="icon-instagram"></span></a></li>
                </ul>
              </div>
              <div class="utility-item">
                <text-size-selector
                  :isopen=true
                  :haslabel=false
                  class="is-align-right"
                >
                </text-size-selector>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import TextSizeSelector from '../components/TextSizeSelector.vue'
import StreamField from '../components/StreamField.vue'

export default {
  name: 'About',
  components: {
    TextSizeSelector,
    StreamField,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      type: 'base.AboutPage',
      slug: 'about',
      loadingText: 'Loading',
      guide: {
        steps: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'getAllPages',
      'isPagesLoaded',
      'getSingleContext',
    ]),
    context: function() {
      return this.getSingleContext(this.slug)
    },
  },
  methods: {
    ...mapActions([
      'fetchPageByPath',
      'fetchPageByType',
      'setGuideSteps'
    ]),
    someFunction: function() {
      
    },
  },
  created() {},
  beforeMount() {
    this.fetchPageByType({ type: this.type, slug: this.slug, lang:this.$root.$i18n.locale })
  },
  mounted() {
    this.setGuideSteps({ steps: this.guide.steps })
  }
}
</script>
